<template>
    <div
            class="visual-menu-item"
            :class="{
                'visual-menu-item_active': active
            }"
            :style="{
                'color': color,
                'border-color': color,
                'font-size': fontSize+'px'
            }"
            @click="click"
    >
        <div>
            <slot name="default"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            color: {type: String, default: '#fff'},
            fontSize: {type: Number, default: 11},
            active: {type: Boolean, default: false},
            to: {type: Object, default: null}
        },
        methods: {
            click() {
                if (this.to) {
                    this.$router.push(this.to).catch(() => {});
                    this.$store.commit('contentReload');
                }
            }
        }
    }
</script>

<style lang="scss">
    .visual-menu-item {
        width: 46px;
        height: 46px;
        line-height: 17px;
        border-width: 1px;
        border-style: solid;
        border-radius: 6px;
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        user-select: none;
        margin: 5px;

        &.visual-menu-item_active {
            cursor: pointer;

            &:hover {
                opacity: 0.7;
            }
        }
    }
</style>